<template>
  <div class="wrapper fixed" style="min-width:1200px">
    <v-header></v-header>
    <v-sider></v-sider>
    <div class="content-wrapper" :class="{ slideCollapse: sidebar.collapsed }">
      <!-- <div class="mainContent">
        <div class="mainContent_banner">{{title}}</div>
        <div class="mainContent_banner_conent">{{textData}}</div>
        <div class="morenotice"><router-link :to="'officialNews'">更多官方消息</router-link> </div>
      </div> -->

      <div class="conent_box_init">
        <div class="conent_box">
          <el-scrollbar tag="div" wrapClass="content-scrollbar">
            <section class="content">
              <!-- <breadcrumb class="breadcrumb-container"></breadcrumb> -->
              <transition
                mode="out-in"
                enter-active-class="fadeIn"
                leave-active-class="fadeOut"
                appear
              >
                <router-view></router-view>
              </transition>
            </section>
          </el-scrollbar>
        </div>
      </div>

      <div class="footer">
        四川云时网络科技有限公司 蜀ICP备2021006045号-1
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VHeader from "./components/Header";
import VSider from "./components/SideBar";
import Breadcrumb from "./components/Breadcrumb";
import { mapActions, mapGetters } from "vuex";
import * as sysApi from "../common/sys";
import "animate.css";
export default {
  name: "home",
  data() {
    return {
      parme: {
        params: {
          page: "1",
          type: 0,
          page_size: "1",
        },
      },
      textData: "",
      title: "",
    };
  },
  components: {
    VHeader,
    VSider,
    Breadcrumb,
  },
  computed: {
    ...mapGetters({
      sidebar: "sidebar",
    }),
  },
  created() {
    // this.initQuery();
  },
  methods: {
    initQuery() {
      sysApi
        .notice(this.parme)
        .then((res) => {
          // console.log(res.result)
          // this.count = res.count;
          this.title = res.result[0].title;
          this.textData = res.result[0].context;
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
  },
};
</script>
<style lang="scss">
html {
  //   background-color: #f5f5f5;
  font-size: 14px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  min-width: 300px;
  overflow-x: hidden;
  /*overflow-y: hidden;*/
  text-rendering: optimizeLegibility;
  box-sizing: border-box;
}
body {
  color: #4a4a4a;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background: #F5F7F7;
}
.content-wrapper {
  position: relative;
  height: 100%;
  background: #F5F7F7;
  -webkit-transition: -webkit-transform 0.3s ease-in-out,
    margin 0.3s ease-in-out;
  -moz-transition: -moz-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
  -o-transition: -o-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, margin 0.3s ease-in-out;
  margin-left: 230px;
  padding-top: 50px;
  .content {
    // padding: 1.25rem;
    .breadcrumb-container {
      margin-bottom: 20px;
    }
  }
  &.slideCollapse {
    margin-left: 44px;
  }
  .el-scrollbar__bar.is-vertical {
    display: none;
  }
}
.animated {
  animation-duration: 0.2s;
  background: #313148;
}

.conent_box_init {
  padding: 32px 50px 0px 100px;
  overflow: auto;
  background: #F5F7F7;
  .conent_box {
    overflow: auto;
    // background: #fff;
    // padding: 20px;
    // border: 10px solid #f3f3f3;
    min-height: 780px;
  }
}
.footer {
  position: relative;
  bottom: 20px;
  text-align: center;
  color: #8A84AC;
  font-size: 12px;
  left: 50%;
  transform: translate(-50%);
}
</style>


